import H3 from "@material-tailwind/react/Heading3";
import React from 'react';
import Fade from 'react-reveal/Fade';

const Skills = () => {
    return (
        <div id='skills' className='w-full min-h-screen'>
            <H3 color="lightBlue">Skills</H3>
            <Fade bottom>
                <div className="w-full grid lg:grid-cols-6 md:grid-cols-4 grid-cols-2 gap-4 pt-8">
                    <i className="m-2 devicon-react-original-wordmark colored text-6xl"></i>
                    <i className="m-2 devicon-nodejs-plain colored text-6xl"></i>
                    <i className="m-2 devicon-express-original colored text-6xl"></i>
                    <i className="m-2 devicon-mongodb-plain-wordmark colored text-6xl"></i>
                    <i className="devicon-firebase-plain-wordmark colored text-6xl"></i>
                    <i className="devicon-jest-plain colored text-6xl"></i>
                    <i className="devicon-graphql-plain-wordmark colored text-6xl"></i>
                    <i className="m-2 devicon-javascript-plain colored text-6xl"></i>
                    <i className="devicon-tailwindcss-plain colored text-6xl"></i>
                    <i className="m-2 devicon-bootstrap-plain colored text-6xl"></i>
                    <i className="m-2 devicon-html5-plain colored text-6xl"></i>
                    <i className="m-2 devicon-css3-plain colored text-6xl"></i>
                    <i className="devicon-git-plain colored text-6xl"></i>
                    <i className="devicon-github-original-wordmark colored text-6xl"></i>

                </div>
            </Fade>
        </div>
    );
};

export default Skills;